// API client for the anonymous shared-topic page (/t/<token>).
//
// Deliberately separate from api.js: nothing here sends auth headers, and the
// public page must never import the authenticated client (its module-level
// audio gate and error paths assume a signed-in app shell).

const API_BASE = process.env.REACT_APP_API_URL || "";

export async function fetchPublicTopic(token) {
  const res = await fetch(`${API_BASE}/api/public/topics/${encodeURIComponent(token)}/`);
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    const e = new Error(data.detail || "Could not load this topic.");
    e.status = res.status;
    throw e;
  }
  return res.json();
}

// Audio is served as cacheable audio/mpeg per URL, so callers point an
// Audio element straight at these — no fetch, no base64.
export function publicTurnAudioUrl(token, turnId) {
  return `${API_BASE}/api/public/topics/${encodeURIComponent(token)}/audio/turn/${turnId}/`;
}

export function publicWordAudioUrl(token, wordId) {
  return `${API_BASE}/api/public/topics/${encodeURIComponent(token)}/audio/word/${wordId}/`;
}
